module.exports = __webpack_public_path__ + "assets/img/22c3b9f868a11d04a786a1e283549758.png";